/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Alert } from 'components/atoms/alert';

const Wrapper = styled.div`
  cursor: pointer;
`;

const UnderlinedSpan = styled.span`
  text-decoration: underline;
`;

export const OrphanTasksInfo: FC<{
  className?: string;
  total: number;
  isOrphanTasksVisible: boolean;
  onOrphanTaskVisibilityChange(): void;
}> = ({
  className,
  total,
  isOrphanTasksVisible,
  onOrphanTaskVisibilityChange,
}) => {
  return total > 0 ? (
    <Wrapper className={className}>
      <Alert
        message={
          <span onClick={onOrphanTaskVisibilityChange}>
            <FormattedMessage
              id="document.tasks.orphan_info"
              values={{ total }}
            />{' '}
            <UnderlinedSpan>
              <FormattedMessage
                id={
                  isOrphanTasksVisible
                    ? 'document.tasks.orphan_info_action_hide'
                    : 'document.tasks.orphan_info_action'
                }
              />
            </UnderlinedSpan>
          </span>
        }
        showIcon
      />
    </Wrapper>
  ) : null;
};
